<div
  class="visibility-trigger"
  [class.minimized]="hasReachedEnd"
  visibilityObserver
  [intersectionThresholds]="thresholds"
  (enteredViewport)="onTriggerEnterView()"
></div>
